import * as moment from "moment";
import { Model } from "./model";

export class DateSollecitoDocumentazione extends Model {
  static apiUrl: string = "date_sollecito_documentazione";

  incarico_id: number;
  valore: moment.Moment | null;

  deserialize(input: any): DateSollecitoDocumentazione {
    const result = super.deserialize(input) as DateSollecitoDocumentazione;

    if (input?.valore) {
      result.valore = moment(input.valore);
    } else {
      result.valore = null;
    }

    return result;
  }
}
